import { useState, useCallback } from 'react';
import { IMapSettings } from '../views/components/Video/MapComponent';
import { mapSettings as initialMapSettings } from 'config/consts';

export type UseMapSettings = {
  mapSettings: IMapSettings;
  handleChangeMapSettings: (settings: Partial<IMapSettings>) => void;
};

export const useMapSettings = (): UseMapSettings => {
  const [mapSettings, setMapSettings] = useState<IMapSettings>(
    initialMapSettings
  );

  const handleChangeMapSettings = useCallback(
    (settings: Partial<IMapSettings>) =>
      setMapSettings((prev) => ({
        ...prev,
        ...settings,
      })),
    []
  );

  return {
    mapSettings,
    handleChangeMapSettings,
  };
};
